<template>
  <button type="button" class="btn" :disabled="start">{{ tmpStr }}</button>
</template>
<style scoped>
.btn {
  background-color: transparent;
  border: none;
}
</style>
<script>
export default {
  name: 'sendcode',
  data () {
    return {
      tmpStr: 'Send code',
      timer: null,
      start: false,
      runSecond: this.second
    }
  },
  props: {
    initStr: String,
    second: {
      default: 60,
      validator (val) {
        return /^\d*$/.test(val)
      }
    },
    runStr: {
      type: String,
      default: '{%s}s'
    },
    resetStr: {
      type: String,
      default: 'Get a new code'
    },
    value: {
      type: Boolean,
      default: false
    },
    storageKey: {
      type: String
    }
  },
  methods: {
    run (lastSecond) {
      let second = lastSecond || this.runSecond
      if (this.storageKey) {
        const runSecond = new Date().getTime() + second * 1000
        window.sessionStorage.setItem(this.storageKey, runSecond)
      }
      if (!lastSecond) {
        this.tmpStr = this.getStr(second)
      }
      this.timer = setInterval(() => {
        second--
        this.tmpStr = this.getStr(second)
        second <= 0 && this.stop()
      }, 1000)
    },
    stop () {
      this.tmpStr = this.resetStr
      this.start = false
      this.$emit('input', false)
      clearInterval(this.timer)
    },
    s_stop () {
      this.tmpStr = '获取验证码'
      this.start = false
      this.$emit('input', false)
      clearInterval(this.timer)
    },
    getStr (second) {
      return this.runStr.replace(/\{([^{]*?)%s(.*?)\}/g, second)
    }
  },
  watch: {
    value (val) {
      this.start = val
      val && this.run()
    }
    // storageKey () {
    //   this.stop()
    //   this.start && this.run()
    // }
  },
  created () {
    const lastSecond = ~~((window.sessionStorage.getItem(this.storageKey) - new Date().getTime()) / 1000)
    if (lastSecond > 0 && this.storageKey) {
      this.tmpStr = this.getStr(lastSecond)
      this.start = true
      this.run(lastSecond)
    } else {
      if (this.initStr) this.tmpStr = this.initStr
    }
  },
  destroyed () {
    !this.storageKey && this.stop()
  }
}
</script>
